// Dashboard Saga

// import saga helpers
import { all, call, fork, put, takeEvery } from "redux-saga/effects";

// import types
import { GET_DASHBOARD_DATA, GET_DASHBOARD_ACTIVITY_LIST } from "./actionType";

// import success fail actions
import {
  getDashboardDataSuccess,
  getDashboardDataError,
  getDashboardActivityListSuccess,
  getDashboardActivityListFail,
} from "./action";

// import fakebackend_api
import {
  getDashboardDataAPI,
  getDashboardActivityListAPI,
} from "../../helpers/fakebackend_helper";

function* getDashboardData() {
  try {
    const response = yield call(getDashboardDataAPI);
    yield put(getDashboardDataSuccess(response));
  } catch (error) {
    yield put(getDashboardDataError(error));
  }
}

export function* watchGetDashboardData() {
  yield takeEvery(GET_DASHBOARD_DATA, getDashboardData);
}

function* getDashboardActivityList() {
  try {
    const response = yield call(getDashboardActivityListAPI);
    yield put(getDashboardActivityListSuccess(response));
  } catch (error) {
    yield put(getDashboardActivityListFail(error));
  }
}

export function* watchGetDashboardActivityList() {
  yield takeEvery(GET_DASHBOARD_ACTIVITY_LIST, getDashboardActivityList);
}

function* Dashboard() {
  yield all([fork(watchGetDashboardData), fork(watchGetDashboardActivityList)]);
}

export default Dashboard;
